import {h, Fragment} from "preact"
import Products from './Products'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'
import BottomToolbar from './BottomToolbar'
import SelectedFilters from './SelectedFilters'
import { wrapContent } from './ContentWrapper'
import NoResults from './NoResults'

export function CategoryBody({ loading, foundProducts }) {
    if (loading) {
        return null;
    }

    return foundProducts ? (
        <>
            <div class="v-stack">
                <Toolbar />
                <div class="collection">
                    <Sidebar />
                    <div class="collection__main">
                        <SelectedFilters />
                        <Products />
                        <BottomToolbar />
                    </div>
                </div>
            </div>
        </>
    ) : (
        <NoResults />
    )
}

export default wrapContent('category', CategoryBody)